import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from 'firebase/firestore';
import { db } from '../config/firebase';
import type { University, UniversityFormData } from '../types';

export const getUniversities = async (): Promise<University[]> => {
  const querySnapshot = await getDocs(collection(db, 'universities'));
  return querySnapshot.docs.map(d => ({ id: d.id, ...d.data() } as University));
};

export const addUniversity = async (data: UniversityFormData): Promise<University> => {
  const docRef = await addDoc(collection(db, 'universities'), data);
  return { id: docRef.id, ...data };
};

export const updateUniversity = async (id: string, data: UniversityFormData): Promise<University> => {
  const universityRef = doc(db, 'universities', id);
  await updateDoc(universityRef, data);
  return { id, ...data };
};

export const deleteUniversity = async (id: string): Promise<string> => {
  const universityRef = doc(db, 'universities', id);
  await deleteDoc(universityRef);
  return id;
};
